import React, { createContext, useContext, useState, ReactNode } from "react";

interface SessionData {
    [key: string]: any;
}

interface SessionContextType {
    session: SessionData;
    setSession: (data: Partial<SessionData>) => void;
    clearSession: () => void;
}

const SessionContext = createContext<SessionContextType | undefined>(undefined);

export const SessionProvider = ({ children }: { children: ReactNode }) => {
    const [session, setSessionState] = useState<SessionData>({});

    const setSession = (data: Partial<SessionData>) => {
        setSessionState((prev) => ({ ...prev, ...data }));
    };

    const clearSession = () => {
        setSessionState({});
    };

    return (
        <SessionContext.Provider value={{ session, setSession, clearSession }}>
            {children}
        </SessionContext.Provider>
    );
};

export const useSession = () => {
    const context = useContext(SessionContext);
    if (context === undefined) {
        throw new Error("useSession must be used within a SessionProvider");
    }
    return context;
};
